import React, { useState } from 'react';
import { ListOrdered, History } from 'lucide-react';
import { colors } from '../../constants/theme';
import PhaseSelector from '../Common/PhaseSelector';
import CategorySelector from '../Common/CategorySelector';
import GroupTable from '../Common/GroupTable';
import GroupHistory from '../Common/GroupHistory';
import EliminationBracket from '../Common/EliminationBracket';

const GROUP_VIEWS = [
  { key: 'classificacao', label: 'Classificação', Icon: ListOrdered },
  { key: 'historico', label: 'Histórico', Icon: History },
];

const RankingsView = () => {
  const [selectedCategory, setSelectedCategory] = useState('juvenil'); // ✅ Categoria que tem dados
  const [selectedPhase, setSelectedPhase] = useState('grupos');
  const [groupView, setGroupView] = useState('classificacao');

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-center" style={{ color: colors.primary }}>
        Chaves e Rankings
      </h2>

      <PhaseSelector
        selectedPhase={selectedPhase}
        onPhaseChange={setSelectedPhase}
      />

      {/* ✅ CORREÇÃO: Mostrar seletor de categoria para todas as fases */}
      <CategorySelector
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
      />

      {selectedPhase === 'grupos' && (
        <>
          {/* Classificação e histórico são visões da mesma fase; separá-las
              evita empilhar a tabela e todas as partidas na mesma tela. */}
          <div className="flex justify-center gap-2">
            {GROUP_VIEWS.map(({ key, label, Icon }) => (
              <button
                key={key}
                onClick={() => setGroupView(key)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium ${
                  groupView === key ? 'text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
                style={{
                  backgroundColor: groupView === key ? colors.primary : 'white',
                }}
              >
                <Icon className="h-4 w-4" />
                {label}
              </button>
            ))}
          </div>

          {groupView === 'classificacao' ? (
            <GroupTable category={selectedCategory} />
          ) : (
            <GroupHistory category={selectedCategory} />
          )}
        </>
      )}

      {(selectedPhase === 'quartas' || selectedPhase === 'semifinal' || selectedPhase === 'final') && (
        <EliminationBracket
          phase={selectedPhase}
          category={selectedCategory}
        />
      )}
    </div>
  );
};

export default RankingsView;
